<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>ទិន្នន័យស្ថិតិប្រចាំថ្ងៃ</h4>
							</div>
							<stat-card data-background-color="orange">
								<template slot="icon">groups</template>
								<template slot="title">ចំនួនអតិថិជនថ្មី</template>
								<template slot="value">{{today.total_user}}</template>
								<template slot="tag">-</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលការជួល</template>
								<template slot="value">{{config.moneylify(today.total_rent_income)}}</template>
								<template slot="tag">{{config.get_usd(today.total_rent_income)}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលការជាវសមាជិក</template>
								<template slot="value">{{config.moneylify(today.total_member_income)}}</template>
								<template slot="tag">{{config.get_usd(today.total_member_income)}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលសរុប</template>
								<template slot="value">{{config.moneylify(today.total_rent_income + today.total_member_income)}}</template>
								<template slot="tag">{{config.get_usd(today.total_rent_income + today.total_member_income)}}</template>
							</stat-card>
						</div>
					</md-card-content>
				</md-card>
			</div>
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>ទិន្នន័យសរុប</h4>
							</div>
							<stat-card data-background-color="orange">
								<template slot="icon">video_call</template>
								<template slot="title">ចំនួនភាពយន្ត</template>
								<template slot="value">{{overall.total_film}}</template>
								<template slot="tag">-</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">groups</template>
								<template slot="title">ចំនួនអតិថិជន</template>
								<template slot="value">{{overall.total_user}}</template>
								<template slot="tag">-</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូល</template>
								<template slot="value">{{config.moneylify(overall.total_income)}}</template>
								<template slot="tag">{{config.get_usd(overall.total_income)}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនទឹកប្រាក់ក្នុងកាបូប</template>
								<template slot="value">{{config.moneylify(overall.total_wallet_balance)}}</template>
								<template slot="tag">{{config.get_usd(overall.total_wallet_balance)}}</template>
							</stat-card>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>ទិន្នន័យភាពយន្ត</h4>
							</div>
							<stat-card data-background-color="orange">
								<template slot="icon">video_call</template>
								<template slot="title">ចំនួនរឿងភាពយន្ត</template>
								<template slot="value">{{overall.total_movie_film}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">video_call</template>
								<template slot="title">ចំនួនរឿងជួល</template>
								<template slot="value">{{overall.total_rental_film}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">video_call</template>
								<template slot="title">ចំនួនរឿងសមាជិក</template>
								<template slot="value">{{overall.total_member_film}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">video_call</template>
								<template slot="title">ចំនួនរឿងភាគ</template>
								<template slot="value">{{overall.total_series_film}}</template>
							</stat-card>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>ទិន្នន័យសមាជិក</h4>
							</div>
							<stat-card data-background-color="orange">
								<template slot="icon">subscriptions</template>
								<template slot="title">ចំនួនសមាជិកដំណើរការសរុប</template>
								<template slot="value">{{overall.total_active_member}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">subscriptions</template>
								<template slot="title">សមាជិកមានរយៈពេលតិចជាង ៧ ថ្ងៃ</template>
								<template slot="value">{{overall.total_active_member_under_7}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">subscriptions</template>
								<template slot="title">សមាជិកមានរយៈពេលតិចជាង ៣០ ថ្ងៃ</template>
								<template slot="value">{{overall.total_active_member_under_30}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">subscriptions</template>
								<template slot="title">សមាជិកមានរយៈពេលតិចជាង ៩០ ថ្ងៃ</template>
								<template slot="value">{{overall.total_active_member_under_90}}</template>
							</stat-card>
						</div>
					</md-card-content>
				</md-card>
			</div>

			
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>ទិន្នន័យស្ថិតិប្រចាំខែ{{config.month_km_list[(new Date()).getMonth()]}}</h4>
							</div>
							<stat-card data-background-color="orange">
								<template slot="icon">groups</template>
								<template slot="title">ចំនួនអតិថិជនថ្មី</template>
								<template slot="value">{{month.total_user}}</template>
								<template slot="tag">-</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលការជួល</template>
								<template slot="value">{{config.moneylify(month.total_rent_income)}}</template>
								<template slot="tag">{{config.get_usd(month.total_rent_income)}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលការជាវសមាជិក</template>
								<template slot="value">{{config.moneylify(month.total_member_income)}}</template>
								<template slot="tag">{{config.get_usd(month.total_member_income)}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលសរុប</template>
								<template slot="value">{{config.moneylify(month.total_rent_income + month.total_member_income)}}</template>
								<template slot="tag">{{config.get_usd(month.total_rent_income + month.total_member_income)}}</template>
							</stat-card>
						</div>
					</md-card-content>
				</md-card>
			</div>

			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>{{translate(locale.statisticsRange)}}</h4>
							</div>
							
							<div class="md-layout-item md-small-size-50 md-size-33">
								<md-field>
									<label>{{translate(locale.startDate)}}</label>
									<md-input type="text" v-model="search.start_date" style="display:none" />
									<datetime type="datetime" v-model="search.start_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-33">
								<md-field>
									<label>{{translate(locale.endDate)}}</label>
									<md-input type="text" v-model="search.end_date" style="display:none" />
									<datetime type="datetime" v-model="search.end_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-button class="md-raised md-primary" @click="getRange()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
							<stat-card data-background-color="orange">
								<template slot="icon">groups</template>
								<template slot="title">ចំនួនអតិថិជនថ្មី</template>
								<template slot="value">{{range.total_user}}</template>
								<template slot="tag">-</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលការជួល</template>
								<template slot="value">{{config.moneylify(range.total_rent_income)}}</template>
								<template slot="tag">{{config.get_usd(range.total_rent_income)}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលការជាវសមាជិក</template>
								<template slot="value">{{config.moneylify(range.total_member_income)}}</template>
								<template slot="tag">{{config.get_usd(range.total_member_income)}}</template>
							</stat-card>
							<stat-card data-background-color="orange">
								<template slot="icon">attach_money</template>
								<template slot="title">ចំនួនប្រាក់ចំណូលសរុប</template>
								<template slot="value">{{config.moneylify(range.total_rent_income + range.total_member_income)}}</template>
								<template slot="tag">{{config.get_usd(range.total_rent_income + range.total_member_income)}}</template>
							</stat-card>
							
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	import StatCard from '@/components/StatCard'
	export default {
		components: {
			StatCard,
			Datetime
		},
		created() {
			if(!this.allow_user("super-admin|operation-admin")) {
				
				if(this.$store.state.authentication.user_role == "payment-admin") {
					this.$router.replace("/payments");
				}
				if(this.$store.state.authentication.user_role == "film-admin") {
					this.$router.replace("/films");
				}
			}

			this.getStatistics();

		},
		data() {
			return {
				loaded: false,
				rangeLoaded: false,
				search: {
					start_date: "",
					end_date: ""
				},
				overall: {
					total_film: 0,
					total_user: 0,
					total_income: 0,
					total_wallet_balance: 0,
					total_admin: 0,

					total_movie_film: 0,
					total_series_film: 0,
					total_rental_film: 0,
					total_member_film: 0,

					total_active_member: 0,
					total_active_member_under_7: 0,
					total_active_member_under_30: 0,
					total_active_member_under_90: 0
				},
				today: {
					total_user: 0,
					total_rent_income: 0,
					total_member_income: 0
				},
				month: {
					total_user: 0,
					total_rent_income: 0,
					total_member_income: 0
				},
				range: {
					total_user: 0,
					total_rent_income: 0,
					total_member_income: 0
				}
			}
		},
		methods: {
			getStatistics(more = false) {
				this.$http.get(this.config.api + "/user/stat/overall").then(data => {
					this.overall = data.body.data;
					this.getToday();
					this.getMonth();
				})
			},
			getToday() {
				var date = new Date();
				var y = date.getFullYear(), m = date.getMonth(), d = date.getDate();

				var start_date = parseInt(((new Date(y, m, d, 0, 0, 0, 0)).getTime()));
				var end_date = parseInt(((new Date(y, m, d, 23, 59, 59, 999)).getTime()));

				this.$http.get(this.config.api + "/user/stat/range/" + start_date + "/" + end_date).then(data => {
					this.today = data.body.data;
					this.loaded = true;
				});
			},
			getMonth() {
				var date = new Date();
				var y = date.getFullYear(), m = date.getMonth(), d = date.getDate();

				var start_date = parseInt(((new Date(y, m, 1, 0, 0, 0, 0)).getTime()));
				var end_date = parseInt(((new Date(y, m + 1, 0, 23, 59, 59, 999)).getTime()));

				this.$http.get(this.config.api + "/user/stat/range/" + start_date + "/" + end_date).then(data => {
					this.month = data.body.data;
					this.loaded = true;
				});
			},
			getRange() {

				this.rangeLoaded = false;
				let start_date = (new Date(this.search.start_date)).getTime();
				let end_date = (new Date(this.search.end_date)).getTime();

				this.$http.get(this.config.api + "/user/stat/range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data
					this.rangeLoaded = true;
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue